import {
  __,
  el,
  SelectControl,
} from '../../common/variables';
import { cl } from '../../common/functions';

const editSearch = (props) => {
  const { className, isSelected, attributes, setAttributes, setMetaValue } = props;
  return el(SelectControl,
    {
      label: __('Selectionner le type de recherche de la carte'),
      title: __('Selectionner le type de recherche de la carte'),
      className: "select-box",
      options: [
        { label: __('Recherche via Leaflet'), value: 'leaflet' },
        { label: __('Recherche via les nom d\'entités'), value: 'custom' }
      ],
      value: attributes.search,
      onChange: (value) => {
        setAttributes({ search: value });
      },
      onFocus: (e) => {
        const thisElement = e.target;
        const label = thisElement.parentNode.parentNode.querySelector('label');
        if (label) {
          label.classList.add('select-focused');
        }
      },
      onBlur: (e) => {
        const thisElement = e.target;
        const label = thisElement.parentNode.parentNode.querySelector('label');
        if (label) {
          label.classList.remove('select-focused');
        }
      }
    }
  )
}

export { editSearch }
